import type { SonosSpeaker } from '../../services/sonosApi';

export function parseSonosTime(value?: string | null): number | null {
  if (!value) return null;
  const parts = value.split(':').map((p) => Number(p));
  if (parts.some((n) => Number.isNaN(n))) return null;
  if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
  if (parts.length === 2) return parts[0] * 60 + parts[1];
  if (parts.length === 1) return parts[0];
  return null;
}

export function formatClock(totalSec: number): string {
  const sec = Math.max(0, Math.floor(totalSec));
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function formatRemaining(totalSec: number): string {
  return `-${formatClock(totalSec)}`;
}

/** Destino elegido sin sesión activa: no mostrar metadata heredada del parlante Sonos. */
export function coordinatorForPlayerDisplay(
  coordinator: SonosSpeaker | null,
  showNowPlaying: boolean,
): SonosSpeaker | null {
  if (!coordinator) return null;
  if (showNowPlaying) return coordinator;
  return {
    ...coordinator,
    playback_state: 'idle',
    current_title: null,
    current_artist: null,
    current_album: null,
    current_album_art_url: null,
    playing_source_name: null,
    track_position: null,
    track_duration: null,
  };
}
